import { TalentPage } from 'features/public-talent/TalentPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { config } from 'utils/config';

export default TalentPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-new'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
